module.exports = __webpack_public_path__ + "static/omega_g3-01492dab97f54d04adadb9a79b17699b.jpg";